import React, { Component } from 'react';
import { Link} from "react-router-dom";
import axios from 'axios';
import {convertDate, currency, orderResult} from '../Utils';
import Loading from './Loading';
import { config } from '../Configurator'

// import CurrencyFormat from 'react-currency-format';

class CoursesTable extends Component {

    constructor(props) {
        super(props);
        this.userChange = this.userChange.bind(this);
        this.state = {
            loading: true,
            users: [],
            user: null,
            job_states: [],
            job_state: null,
            cases: [], // filtered cases only
            cases_all: []
        } 
    }

    userChange(event) {
        let {name: fieldName, value} = event.target;
        this.load();
    }

    componentDidMount() {
        // default state is Live, default user is myself
        this.setState({ job_state: 'Confirmed Course', user: localStorage.getItem('bo_email') }, ()=>{ 
            this.load();
        })
    }

    load() {


        if(this.state.cases_all.length > 0) {
            this.filterResults(this.state.cases_all);
            return false;
        }

        let that = this;
        this.setState({ loading: true });

        // if(value===null) value = localStorage.getItem('bo_email');
        axios.post(config().base_url + 'GetActiveTrainingCoursesListJSON2', {
            "Username": localStorage.getItem('bo_email'),
            "Password": localStorage.getItem('bo_password'),
            "PrimaryGroup" : "",
            "CourseCode" : "",
            "StartDate" : "",
            "EndDate" : "",
            "MatterType" : "",
            "CourseStatus" : "",
            "CourseVenue" : ""
        })
        .then(response => {

            that.filterResults(response.data.d.Records);
            
            // fake response, testing purpose only
            // let r = this.fake_response();
            // that.filterResults(r.d.Records);
        })
        .catch(error => {
            this.setState({loading: false});
            console.log(error);
        });
    }

    filterResults(cases_all) {
            // console.log(response.data.d.Records);

            // filter by jobstatus  
            let records = cases_all;
            let filtered_list = [];
            let job_states = [];
            let users = [];
            let that = this;

            let job_state = that.state.job_state;
            // alert(job_state);
            if(!job_state) job_state = "";

            // cycle response
            for(let i=0; i < records.length; i++) {

                let found_user = false;
                let found_job_status = false;

                // populate job states dropdown with unique values
                if(records[i].JobStatus) {
                    let js = records[i].JobStatus;

                    // if(js=="Workout" || js=="Recovery" || js=="Live") js = "Active";
                    if(!job_states.includes(js)) {
                        job_states.push(js);
                    }

                    if(job_state == js) {
                        found_job_status = true;
                    }
                }


                // populate users with unique values
                // multiple values to look at = CaseOwner, CaseUnderWriter, CaseProcessor, CaseAdditionalUser1, CaseAdditionalUser2
                ['CaseOwner', 'CaseUnderWriter', 'CaseProcessor', 'CaseAdditionalUser1', 'CaseAdditionalUser2'].forEach(key => {
                    if(typeof records[i][key] != 'undefined') {
                        if(that.state.user == records[i][key]) {
                            found_user = true;
                        }
                        if(!users.includes(records[i][key]) && records[i][key]) {
                            users.push(records[i][key]);
                        }
                    }    
                });

                // filter users for unwanted ones
                for(let i=0; i < users.length; i++) {
                    if(config().cleanUpNames.includes(users[i])) {
                        users.splice(i, 1);
                    }
                }

                // filter results
                // console.log(that.state.job_state + ', ' + found_job_status + ',' + that.state.user + ',' + found_user)
                if((!job_states || found_job_status) && (!that.state.user || found_user)) {  
                    filtered_list.push(records[i]);
                }

            }

            job_states.sort();
            users.sort();
            // job_states.unshift(null); // initial selected option in blank as first element
            users.unshift(null); // initial selected option in blank as first element

            this.setState({cases: orderResult(filtered_list, 'DateCreated', 'desc'), cases_all: cases_all, job_states: job_states, users: users, loading: false});
    }

    fake_response()
    {
        return {"d":{"__type":"OrangeMail.BrightofficeAPI+EnquiryListResult","EnquiryResult":{"__type":"OrangeMail.BrightofficeAPI+SuccessInfo","SuccessCode":0,"Message":null},"Records":[{"__type":"OrangeMail.BrightofficeAPI+Job","JobReference":"CA051532","DateCreated":"/Date(1614643200000)/","Firstname":"Live2","Surname":"Test","MatterType":"Business-Finance","HomeTelephone":null,"WorkTelephone":null,"Mobile":null,"Email":null,"Salutation":null,"Address":{"HouseName":null,"HouseNumber":null,"Address1":"123456789012345678901234567890123456789012345678901234567890","Address2":null,"Address3":null,"Address4":null,"PostCode":null},"CustomerCode":"C000717","MatterTypeDescription":null,"JobStatus":"Rework","JobStatusDescription":"02-03-2021 16:26","Engineer1Name":null,"Engineer1Label":null,"Engineer1JobStartDate":null,"Engineer1JobEndDate":null,"Engineer2Name":null,"Engineer2Label":null,"Engineer2JobStartDate":null,"Engineer2JobEndDate":null,"Firstname2":null,"Surname2":null,"HomeTelephone2":null,"WorkTelephone2":null,"Mobile2":null,"Email2":null,"CaseType":"LoansMort","CustomerNames":"live2","IsFilterByAppointmentsDateAndTime":false,"AppointmentEndDate":null,"Priority":null,"PriorityDescription":null,"HasChanges":false,"DataFolder":[],"JobDetails":null,"InstallerNumber":null,"IsAllowUserReassignJobToThemselves":false,"EngineerType":null,"LoanAmount":6197,"Term":60,"RepaymentType":"Flat Rate","TermType":"Months","LoanType":"Pay Day Loan","TotalAmount":null,"CaseOwner":"anne2.ibbetson","CustomerOwner":"karen2.paige","CaseUnderWriter":"tom2.flannery","CaseProcessor":"chris2.ibbetson","CaseAdditionalUser1":null,"CaseAdditionalUser2":null},{"__type":"OrangeMail.BrightofficeAPI+Job","JobReference":"CA051533","DateCreated":"/Date(1614729600000)/","Firstname":"Live","Surname":"Perry","MatterType":"Business-Finance","HomeTelephone":null,"WorkTelephone":null,"Mobile":null,"Email":null,"Salutation":null,"Address":{"HouseName":null,"HouseNumber":null,"Address1":null,"Address2":null,"Address3":null,"Address4":null,"PostCode":null},"CustomerCode":"C000706","MatterTypeDescription":null,"JobStatus":"Live","JobStatusDescription":"03-03-2021 08:34","Engineer1Name":null,"Engineer1Label":null,"Engineer1JobStartDate":null,"Engineer1JobEndDate":null,"Engineer2Name":null,"Engineer2Label":null,"Engineer2JobStartDate":null,"Engineer2JobEndDate":null,"Firstname2":null,"Surname2":null,"HomeTelephone2":null,"WorkTelephone2":null,"Mobile2":null,"Email2":null,"CaseType":"LoansMort","CustomerNames":"live","IsFilterByAppointmentsDateAndTime":false,"AppointmentEndDate":null,"Priority":null,"PriorityDescription":null,"HasChanges":false,"DataFolder":[],"JobDetails":null,"InstallerNumber":null,"IsAllowUserReassignJobToThemselves":false,"EngineerType":null,"LoanAmount":21634.67,"Term":12,"RepaymentType":"Interest Only","TermType":"Months","LoanType":"Loan (S)","TotalAmount":null,"CaseOwner":"chris1.ibbetson","CustomerOwner":"karen1.paige","CaseUnderWriter":"tom1.flannery","CaseProcessor":"chris1.ibbetson","CaseAdditionalUser1":null,"CaseAdditionalUser2":null},{"__type":"OrangeMail.BrightofficeAPI+Job","JobReference":"CA051534","DateCreated":"/Date(1614729600000)/","Firstname":"Live","Surname":"Perry","MatterType":"Business-Finance","HomeTelephone":null,"WorkTelephone":null,"Mobile":null,"Email":null,"Salutation":null,"Address":{"HouseName":null,"HouseNumber":null,"Address1":null,"Address2":null,"Address3":null,"Address4":null,"PostCode":null},"CustomerCode":"C000706","MatterTypeDescription":null,"JobStatus":"Live","JobStatusDescription":"03-03-2021 09:16","Engineer1Name":null,"Engineer1Label":null,"Engineer1JobStartDate":null,"Engineer1JobEndDate":null,"Engineer2Name":null,"Engineer2Label":null,"Engineer2JobStartDate":null,"Engineer2JobEndDate":null,"Firstname2":null,"Surname2":null,"HomeTelephone2":null,"WorkTelephone2":null,"Mobile2":null,"Email2":null,"CaseType":"LoansMort","CustomerNames":"live","IsFilterByAppointmentsDateAndTime":false,"AppointmentEndDate":null,"Priority":null,"PriorityDescription":null,"HasChanges":false,"DataFolder":[],"JobDetails":null,"InstallerNumber":null,"IsAllowUserReassignJobToThemselves":false,"EngineerType":null,"LoanAmount":1000,"Term":12,"RepaymentType":"Interest Only","TermType":"Months","LoanType":"Loan (S)","TotalAmount":null,"CaseOwner":"chris1.ibbetson","CustomerOwner":"karen1.paige","CaseUnderWriter":"tom1.flannery","CaseProcessor":"chris1.ibbetson1","CaseAdditionalUser1":null,"CaseAdditionalUser2":null},{"__type":"OrangeMail.BrightofficeAPI+Job","JobReference":"CA051535","DateCreated":"/Date(1614729600000)/","Firstname":"Live2","Surname":"Test","MatterType":"Business-Finance","HomeTelephone":null,"WorkTelephone":null,"Mobile":null,"Email":null,"Salutation":null,"Address":{"HouseName":null,"HouseNumber":null,"Address1":"123456789012345678901234567890123456789012345678901234567890","Address2":null,"Address3":null,"Address4":null,"PostCode":null},"CustomerCode":"C000717","MatterTypeDescription":null,"JobStatus":"Live2","JobStatusDescription":"03-03-2021 09:31","Engineer1Name":null,"Engineer1Label":null,"Engineer1JobStartDate":null,"Engineer1JobEndDate":null,"Engineer2Name":null,"Engineer2Label":null,"Engineer2JobStartDate":null,"Engineer2JobEndDate":null,"Firstname2":null,"Surname2":null,"HomeTelephone2":null,"WorkTelephone2":null,"Mobile2":null,"Email2":null,"CaseType":"LoansMort","CustomerNames":"live2","IsFilterByAppointmentsDateAndTime":false,"AppointmentEndDate":null,"Priority":null,"PriorityDescription":null,"HasChanges":false,"DataFolder":[],"JobDetails":null,"InstallerNumber":null,"IsAllowUserReassignJobToThemselves":false,"EngineerType":null,"LoanAmount":1000,"Term":12,"RepaymentType":"Interest Only","TermType":"Months","LoanType":"Loan (S)","TotalAmount":null,"CaseOwner":"chris2.ibbetson","CustomerOwner":"karen2.paige","CaseUnderWriter":"tom2.flannery","CaseProcessor":"chris2.ibbetson","CaseAdditionalUser1":"additional2.user","CaseAdditionalUser2":null}],"TotalRecordCount":null}}
    }

    render() {
        const { cases, loading } = this.state;
        return (
            <div>
                <div className="row">
                    <div className="col-md-8"><h4 className="font-weight-bold">Cases</h4></div>
                    <div className="col-md-2">
                        <select style={{ maxWidth: '100%' }} className="filters" value={this.state.job_state} onChange={(e) => this.setState({job_state: e.target.value}, function(){ this.load() })}>
                            {this.state.job_states.map((v) => <option key={v} value={v}>{v}</option>)}
                        </select>
                    </div>
                    <div className="col-md-2">

                        <select style={{ maxWidth: '100%' }} className="filters" value={this.state.user} onChange={(e) => this.setState({user: e.target.value}, function(){ this.load() })}>
                            {this.state.users.map((v) => <option key={v} value={v}>{v}</option>)}
                        </select>
                    </div>
                    {/* <div className="col-md-2"><Link className="btn btn-block btn-sm btn-primary" to="/form/3/2">Quick Quote</Link></div> */}
                    {/* <div className="col-md-2"><Link className="btn btn-block btn-sm btn-primary" to="/form/3">Add Case</Link></div> */}
                </div>
                <div className="row">
                    <div className="col-12 mt-3">
                        {
                            loading ? <Loading></Loading> :
                            <table className="table">
                                <thead>
                                <tr>
                                    <th>Course ref:</th>
                                    <th>Course</th>
                                    <th>Start Date</th>
                                    <th>End Date</th>
                                    <th>Status</th>
                                    <th>Palaces</th>
                                    <th></th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    cases.length ?
                                    cases.map(entry => {
                                        return <tr key={entry.JobReference}>
                                            <td>{ entry.Code }</td>
                                            <td>{ entry.CourseDescription }</td>
                                            <td>{ convertDate(entry.CourseDate) }</td>
                                            <td>{ convertDate(entry.EndDate) }</td>
                                            <td>{ entry.CourseStatus }</td>
                                            <td>{ entry.AvailablePlaces }</td>
                                            <td>{ entry.Code }</td>
                                            <td>
                                                <Link to={ '/course/' + entry.Code } className="btn-more"></Link>
                                            </td>
                                        </tr> 
                                    }) : 
                                    null
                                }
                            </tbody>
                        </table>
                    }
                    </div>
                </div>
            </div>
        )
    }

}

export default CoursesTable;